import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useClientAuth } from '../../context/ClientAuthContext'
import { API_BASE_URL } from '../../configs/config'
import { useBranding, logoFor, onLogoError } from '../../branding'
import './ClientPortal.css'

export default function ClientLogin() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useClientAuth()
  const navigate = useNavigate()

  // Branded login link: ?c=<portal URL name> (set on the dashboard's Clients page)
  const [params] = useSearchParams()
  const slug = params.get('c')
  const [branding, setBranding] = useState(null)
  useEffect(() => {
    if (!slug) return
    fetch(`${API_BASE_URL}/branding/${encodeURIComponent(slug)}`)
      .then(r => r.json())
      .then(d => { if (d.success) setBranding(d.branding) })
      .catch(() => {})
  }, [slug])
  useBranding(branding)
  const theme = document.documentElement.getAttribute('data-theme') || 'dark'

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const result = await login(username, password)

    if (result.success) {
      navigate('/')
    } else {
      setError(result.error)
    }
    setLoading(false)
  }

  return (
    <div className="client-login-page">
      <div className="client-login-container">
        <div className="client-login-header">
          <div className="client-logo">
            {branding?.logo_url
              ? <img src={logoFor(branding, theme)} onError={(e) => onLogoError(e, theme)} alt={branding.title || ''}
                  style={{ maxHeight: 56, maxWidth: 220, objectFit: 'contain' }} />
              : <>
                  <span className="logo-icon">R</span>
                  <span className="logo-text">Redstone</span>
                </>}
          </div>
          <h1>{branding?.title ? `${branding.title} Portal` : 'Client Portal'}</h1>
          <p>{branding?.welcome_text || 'Sign in to manage your bots and billing'}</p>
        </div>

        <form onSubmit={handleSubmit} className="client-login-form">
          {error && (
            <div className="client-error-message">
              {error}
            </div>
          )}

          <div className="client-form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
              autoComplete="username"
            />
          </div>

          <div className="client-form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="client-login-btn"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="client-login-footer">
          <p>Need help? Contact <a href="mailto:support@byredstone.com">support@byredstone.com</a></p>
        </div>
      </div>
    </div>
  )
}
